export const SERVICE_OPPORTUNITIES_ROUTES = {
  get: '/hlx/job-responses/service-opportunities',
};

export const SERVICE_OPPORTUNITY_ROUTES = {
  get: '/hlx/job-responses/service-opportunities/{responseId}',
};

export const SERVICE_OPPORTUNITY_COUNTER_ROUTES = {
  post: '/hlx/job-responses/service-opportunities/{responseId}/counter',
};

export const SERVICE_OPPORTUNITY_COUNTER_AVAILABILITY_ROUTES = {
  get: '/hlx/job-responses/service-opportunities/{responseId}/counter-availability',
};
